import { render, staticRenderFns } from "./PasswordSetup.vue?vue&type=template&id=7b97e5dd&scoped=true&"
import script from "./PasswordSetup.vue?vue&type=script&lang=js&"
export * from "./PasswordSetup.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSetup.vue?vue&type=style&index=0&id=7b97e5dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b97e5dd",
  null
  
)

export default component.exports